import { create } from 'zustand';

export type WorkflowStatus =
  | 'idle'
  | 'requesting'
  | 'completed'
  | 'errored'
  | 'timed-out';

export interface AIWorkflowJobResult<T> {
  jobId: string;
  result: null | T;
  error: null | string;
  location: string;
  streamLocation: string;
  runId: string | null;
}

export interface AIWorkflowState<T> {
  jobStarted: () => void;
  workflowResult: AIWorkflowJobResult<T> | undefined;
  setResults: (results: AIWorkflowJobResult<T>) => void;
  setHasTimedOut: () => void;
  setHasErrored: (message?: string) => void;
  status: WorkflowStatus;
  reset: () => void;
  errorMessage: string | undefined;
}

export function createAiWorkflowStore<T>() {
  return create<AIWorkflowState<T>>((set) => ({
    jobStarted: () =>
      set(() => ({
        status: 'requesting',
        workflowResult: undefined,
        errorMessage: undefined,
      })),
    workflowResult: undefined,
    setResults: (result: AIWorkflowJobResult<T>) => {
      set(() => ({
        workflowResult: result,
        status: 'completed',
      }));
    },
    setHasTimedOut: () => {
      set(() => ({
        status: 'timed-out',
        workflowResult: undefined,
      }));
    },
    setHasErrored: (message?: string) => {
      set(() => ({
        status: 'errored',
        errorMessage: message,
      }));
    },
    status: 'idle',
    reset: () => {
      set(() => ({
        status: 'idle',
        workflowResult: undefined,
        errorMessage: undefined,
      }));
    },
    errorMessage: undefined,
  }));
}
